module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/~/babel-runtime/core-js/symbol/iterator.js
// module id = 843
// module chunks = 0